export enum FileMimeTypeModel {
	AAC = 'audio/aac',
	ABW = 'application/x-abiword',
	ARC = 'application/x-freearc',
	AVI = 'video/x-msvideo',
	AZW = 'application/vnd.amazon.ebook',
	BIN = 'application/octet-stream',
	BMP = 'image/bmp',
	BZIP = 'application/x-bzip',
	BZIP2 = 'application/x-bzip2',
	CSH = 'application/x-csh',
	CSS = 'text/css',
	CSV = 'text/csv',
	DOC = 'application/msword',
	DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	EOT = 'application/vnd.ms-fontobject',
	EPUB = 'application/epub+zip',
	GZIP = 'application/gzip',
	GIF = 'image/gif',
	HTM = 'text/html',
	HTML = 'text/html',
	ICO = 'image/vnd.microsoft.icon',
	ICS = 'text/calendar',
	JAR = 'application/java-archive',
	JPG = 'image/jpeg',
	JPEG = 'image/jpeg',
	JS = 'text/javascript',
	JSON = 'application/json',
	JSONLD = 'application/ld+json',
	MID = 'audio/midi audio/x-midi',
	MIDI = 'audio/midi audio/x-midi',
	MJS = 'text/javascript',
	MP3 = 'audio/mpeg',
	MPEG = 'video/mpeg',
	MPKG = 'application/vnd.apple.installer+xml',
	ODP = 'application/vnd.oasis.opendocument.presentation',
	ODS = 'application/vnd.oasis.opendocument.spreadsheet',
	ODT = 'application/vnd.oasis.opendocument.text',
	OGA = 'audio/ogg',
	OGV = 'video/ogg',
	OGX = 'application/ogg',
	OPUS = 'audio/opus',
	OTF = 'font/otf',
	PNG = 'image/png',
	PDF = 'application/pdf',
	PHP = 'application/php',
	PPT = 'application/vnd.ms-powerpoint',
	PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
	RAR = 'application/x-rar-compressed',
	RTF = 'application/rtf',
	SH = 'application/x-sh',
	SVG = 'image/svg+xml',
	SWF = 'application/x-shockwave-flash',
	TAR = 'application/x-tar',
	TIF = 'image/tiff',
	TIFF = 'image/tiff',
	TS = 'video/mp2t',
	TTF = 'font/ttf',
	TXT = 'text/plain',
	VSD = 'application/vnd.visio',
	WAV = 'audio/wav',
	WEBA = 'audio/webm',
	WEBM = 'video/webm',
	WEBP = 'image/webp',
	WOFF = 'font/woff',
	WOFF2 = 'font/woff2',
	XHTML = 'application/xhtml+xml',
	XLS = 'application/vnd.ms-excel',
	XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	XML_APPLCATION = 'application/xml',
	XML_TEXT = 'text/xml',
	XUL = 'application/vnd.mozilla.xul+xml',
	ZIP = 'application/zip',
	GP_VIDEO = 'video/3gpp',
	GP_AUDIO = 'audio/3gpp',
	GP2_VIDEO = 'video/3gpp2',
	GP2_AUDIO = 'audio/3gpp2',
	ZIP7 = 'application/x-7z-compressed',
}

export const FileExtensionFromMimeTypeMap: Map<FileMimeTypeModel, string> = new Map([
	[FileMimeTypeModel.AAC, '.aac'],
	[FileMimeTypeModel.ABW, '.abw'],
	[FileMimeTypeModel.ARC, '.arc'],
	[FileMimeTypeModel.AVI, '.avi'],
	[FileMimeTypeModel.AZW, '.azw'],
	[FileMimeTypeModel.BIN, '.bin'],
	[FileMimeTypeModel.BMP, '.bmp'],
	[FileMimeTypeModel.BZIP, '.bz'],
	[FileMimeTypeModel.BZIP2, '.bz2'],
	[FileMimeTypeModel.CSH, '.csh'],
	[FileMimeTypeModel.CSS, '.css'],
	[FileMimeTypeModel.CSV, '.csv'],
	[FileMimeTypeModel.DOC, '.doc'],
	[FileMimeTypeModel.DOCX, '.docx'],
	[FileMimeTypeModel.EOT, '.eot'],
	[FileMimeTypeModel.EPUB, '.epub'],
	[FileMimeTypeModel.GZIP, '.gz'],
	[FileMimeTypeModel.GIF, '.gif'],
	[FileMimeTypeModel.HTM, '.htm'],
	[FileMimeTypeModel.HTML, '.html'],
	[FileMimeTypeModel.ICO, '.ico'],
	[FileMimeTypeModel.ICS, '.ics'],
	[FileMimeTypeModel.JAR, '.jar'],
	[FileMimeTypeModel.JPG, '.jpeg'],
	[FileMimeTypeModel.JPEG, '.jpg'],
	[FileMimeTypeModel.JS, '.js'],
	[FileMimeTypeModel.JSON, '.json'],
	[FileMimeTypeModel.JSONLD, '.jsonld'],
	[FileMimeTypeModel.MID, '.mid'],
	[FileMimeTypeModel.MIDI, '.midi'],
	[FileMimeTypeModel.MJS, '.mjs'],
	[FileMimeTypeModel.MP3, '.mp3'],
	[FileMimeTypeModel.MPEG, '.mpeg'],
	[FileMimeTypeModel.MPKG, '.mpkg'],
	[FileMimeTypeModel.ODP, '.odp'],
	[FileMimeTypeModel.ODS, '.ods'],
	[FileMimeTypeModel.ODT, '.odt'],
	[FileMimeTypeModel.OGA, '.oga'],
	[FileMimeTypeModel.OGV, '.ogv'],
	[FileMimeTypeModel.OGX, '.ogx'],
	[FileMimeTypeModel.OPUS, '.opus'],
	[FileMimeTypeModel.OTF, '.otf'],
	[FileMimeTypeModel.PNG, '.png'],
	[FileMimeTypeModel.PDF, '.pdf'],
	[FileMimeTypeModel.PHP, '.php'],
	[FileMimeTypeModel.PPT, '.ppt'],
	[FileMimeTypeModel.PPTX, '.pptx'],
	[FileMimeTypeModel.RAR, '.rar'],
	[FileMimeTypeModel.RTF, '.rtf'],
	[FileMimeTypeModel.SH, '.sh'],
	[FileMimeTypeModel.SVG, '.svg'],
	[FileMimeTypeModel.SWF, '.swf'],
	[FileMimeTypeModel.TAR, '.tar'],
	[FileMimeTypeModel.TIF, '.tif'],
	[FileMimeTypeModel.TIFF, '.tiff'],
	[FileMimeTypeModel.TS, '.ts'],
	[FileMimeTypeModel.TTF, '.ttf'],
	[FileMimeTypeModel.TXT, '.txt'],
	[FileMimeTypeModel.VSD, '.vsd'],
	[FileMimeTypeModel.WAV, '.wav'],
	[FileMimeTypeModel.WEBA, '.weba'],
	[FileMimeTypeModel.WEBM, '.webm'],
	[FileMimeTypeModel.WEBP, '.webp'],
	[FileMimeTypeModel.WOFF, '.woff'],
	[FileMimeTypeModel.WOFF2, '.woff2'],
	[FileMimeTypeModel.XHTML, '.xhtml'],
	[FileMimeTypeModel.XLS, '.xls'],
	[FileMimeTypeModel.XLSX, '.xlsx'],
	[FileMimeTypeModel.XML_APPLCATION, '.xml'],
	[FileMimeTypeModel.XML_TEXT, '.xml'],
	[FileMimeTypeModel.XUL, '.xul'],
	[FileMimeTypeModel.ZIP, '.zip'],
	[FileMimeTypeModel.GP_AUDIO, '.3gp'],
	[FileMimeTypeModel.GP_VIDEO, '.3gp'],
	[FileMimeTypeModel.GP_AUDIO, '.3g2'],
	[FileMimeTypeModel.GP2_VIDEO, '.3g2'],
	[FileMimeTypeModel.ZIP7, '.7z'],
]);
